(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('dateFilterValue', dateFilterValue);

    function dateFilterValue(lodash) {
        return {
            restrict: 'EA',
            scope: {
                filterValueModel: '=',
                type: '=',
                settingsOverride: '=?'
            },
            controller: dateFilterValueCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/components/filter-values-type/date',
            link: function(scope, elem) {
                var vm = scope.vm;
                var dp_obj = elem.find('input');

                dp_obj.datepicker(angular.extend(vm.dateOptions, vm.settingsOverride || {}));

                var vmFilterModel = vm.filterValueModel;
                if(vmFilterModel){
                    var date = moment(vmFilterModel, vm.display_format).format(vm.save_format);
                    dp_obj.datepicker('setDate', date);
                }

                dp_obj.on('change', function(e) {
                    scope.$apply(function() {
                        var save_value = moment(e.target.value, vm.save_format).toDate();
                        console.log('scope apply', save_value);
                        vm.filterValueModel = save_value;
                    });

                });
            }
        };
    }

    function dateFilterValueCtrl(lodash, FormBuilderService, $scope) {
        var vm = this;
        this.$onInit = function() {

            vm.display_format = lodash.get(vm.element, 'options.display_format', 'dd/mm/yyyy');
            vm.save_format = lodash.get(vm.element, 'options.save_format', 'DD/MM/YYYY');

            vm.dateOptions = angular.merge({
                    format: vm.display_format,
                    autoclose: true,
                    forceParse: false,
                    orientation: 'bottom',
                },
                generateOptions()
            );

        }

        function generateOptions() {
            var option = {};
            var lang = angular.element('html').attr('lang');

            if (lang) {
                option.language = lang;
            }

            return option;
        }
    }
})();